var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-portal", [
    _c("div", { staticClass: "profile-page" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "form",
            {
              attrs: {
                autocomplete: "off",
                method: "post",
                "data-vv-scope": "form",
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveItem.apply(null, arguments)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.saveItem.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("h1", { staticClass: "content-title" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.subPageTitle))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.form.id
                  ? _c("div", { staticClass: "col-sm-auto photos" }, [
                      _c("div", { staticClass: "row h-100" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-4 col-sm-12 mx-auto mb-3 mb-sm-4",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "photo h-100" },
                              [
                                _c("upload-multiple-image", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "",
                                      expression: "''",
                                    },
                                  ],
                                  ref: "uploadImage",
                                  attrs: {
                                    disabled: _vm.readonlyFormItem,
                                    enableMainImage: true,
                                    showImageLimitMessage: false,
                                    maxImage: 1,
                                    multiple: false,
                                    noOverlay: true,
                                    name: "photos",
                                    showDeleteButton: false,
                                    showEditButton: false,
                                  },
                                  model: {
                                    value: _vm.photos,
                                    callback: function ($$v) {
                                      _vm.photos = $$v
                                    },
                                    expression: "photos",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3",
                                expression: "'required|min:3'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              autocomplete: "new-name",
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              type: "text",
                              id: "input-name",
                              name: "name",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("name") },
                              ],
                              error: _vm.fnFirstError("name"),
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.name",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              autocomplete: "new-email",
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              type: "email",
                              id: "input-email",
                              name: "email",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("email") },
                              ],
                              error: _vm.fnFirstError("email"),
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "email",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.email",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.email`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "numeric|min_value:1|min:9|max:14",
                            expression: "'numeric|min_value:1|min:9|max:14'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          autocomplete: "new-phone",
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-phone",
                          name: "phone",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("phone") },
                          ],
                          error: _vm.fnFirstError("phone"),
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "phone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.phone",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.phone`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "digits:9|min_value:1",
                            expression: "'digits:9|min_value:1'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          autocomplete: "new-nif",
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "number",
                          id: "input-nif",
                          name: "nif",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("nif") },
                          ],
                          error: _vm.fnFirstError("nif"),
                        },
                        model: {
                          value: _vm.form.nif,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "nif",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.nif",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.nif`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              !_vm.readonlyFormItem
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group city-form-group city-bg" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { min: 6 },
                                  expression: "{min: 6}",
                                },
                              ],
                              ref: "old_password",
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                autocomplete: "new-password",
                                readonly: _vm.readonlyFormItem,
                                disabled: _vm.readonlyFormItem,
                                type: "password",
                                id: "input-old_password",
                                name: "old_password",
                                inputClasses: [
                                  {
                                    "is-invalid":
                                      _vm.fnHasError("old_password"),
                                  },
                                ],
                                error: _vm.fnFirstError("old_password"),
                              },
                              model: {
                                value: _vm.form.old_password,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "old_password",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.old_password",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t(`${_vm.pageID}.model.old_password`)
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group city-form-group city-bg" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.form.old_password != null,
                                    min: _vm.getMinPasswordLength(),
                                  },
                                  expression:
                                    "{required: form.old_password!=null, min: getMinPasswordLength()}",
                                },
                              ],
                              ref: "new_password",
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                autocomplete: "new-password",
                                readonly: _vm.readonlyFormItem,
                                disabled: _vm.readonlyFormItem,
                                type: "password",
                                id: "input-new_password",
                                name: "new_password",
                                inputClasses: [
                                  {
                                    "is-invalid":
                                      _vm.fnHasError("new_password"),
                                  },
                                ],
                                error: _vm.fnFirstError("new_password"),
                              },
                              model: {
                                value: _vm.form.new_password,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "new_password",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.new_password",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t(`${_vm.pageID}.model.new_password`)
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group city-form-group city-bg" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.form.old_password != null,
                                    confirmed: "new_password",
                                  },
                                  expression:
                                    "{required: form.old_password!=null, confirmed: 'new_password'}",
                                },
                              ],
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                autocomplete: "new-password",
                                readonly: _vm.readonlyFormItem,
                                disabled: _vm.readonlyFormItem,
                                type: "password",
                                id: "input-new_password_confirmation",
                                name: "new_password_confirmation",
                                inputClasses: [
                                  {
                                    "is-invalid": _vm.fnHasError(
                                      "new_password_confirmation"
                                    ),
                                  },
                                ],
                                error: _vm.fnFirstError(
                                  "new_password_confirmation"
                                ),
                                "data-vv-as": "new_password",
                              },
                              model: {
                                value: _vm.form.new_password_confirmation,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "new_password_confirmation",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.new_password_confirmation",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.pageID}.model.new_password_confirmation`
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "buttons-footer",
                {
                  attrs: {
                    enableButtons: !_vm.readonlyFormItem,
                    isDisabled: _vm.isDisabled,
                  },
                  on: {
                    save: _vm.saveItem,
                    cancel: function ($event) {
                      return _vm.handleBack(`${_vm.moduleCode}.dashboard`)
                    },
                  },
                },
                [
                  !_vm.readonlyFormItem
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-tertiary btn-rounded btn-responsive btn-md btn-block z-depth-0",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.triggerFile.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(_vm.photoTitle)) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }